module.exports = __webpack_public_path__ + "2eb6dad1942b14d7ea92eb7f6928b76d.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/docs/drawaoi.png
// module id = 1476
// module chunks = 1